export default __webpack_public_path__ + "static/media/RP.6c1f176d.svg";